const PERSONA_IMAGE_BASE_PATH = '/images/persona/';

export const DefaultPersonaImageKey = "20_f";

const persona_image_keys = [
    "10_f",
    "10_m",
    "20_f", // DefaultPersonaImageKey
    "20_m",
    "30_f",
    "30_m",
    "40_f",
    "40_m",
    "50_f",
    "50_m",
    "60_f",
    "60_m",
    "70_f",
    "70_m",
];

export const PersonaImages = persona_image_keys.map(key => {
        return {
            key,
            src: PERSONA_IMAGE_BASE_PATH + `${key}.jpg`,
        }
    }
);

export function PersonaImagerKey2Src(persona_image_key: string): string {
    const img = PersonaImages.find(pi => pi.key === persona_image_key);
    if (img === undefined) {
        throw new Error("no persona image key");
    }
    return img.src;
}
